exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".duplicate-warning-container {\n  padding: 20px;\n  min-width: 400px;\n}\n\nh2 {\n  margin-top: 0;\n  color: #f44336;\n}\n\n.warning-message {\n  margin: 20px 0;\n  padding: 15px;\n  background-color: #fff3cd;\n  border: 1px solid #ffc107;\n  border-radius: 4px;\n}\n\n.duplicate-info {\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #ddd;\n}\n\n.duplicate-info p {\n  margin: 5px 0;\n}\n\n.actions {\n  margin-top: 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 10px;\n}\n\n.actions button {\n  width: 100%;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/finance/duplicate-document-warning/duplicate-document-warning.component.css
// module id = 1955
// module chunks = 0